import styles from './AlertDialog.module.scss';

import { TextInput, Textarea, FileInput, Box } from '@mantine/core';

import { IconUpload } from '@tabler/icons-react';

import {
  AlertDialogAction,
  messageBoxFormValueInit,
  openLinkFormValueInit,
} from '#/components/ui/messages/model';

import { wrapImageUploadProps } from '#/components/ui/messages/MessageEditor/MessageImageUpload';

import { useActionEditorFormContext } from '../../context';

import { makeKFunc, SelectSubAction } from '../utils';
import { OpenLinkFields } from '../OpenLink';
import { MessageBoxFields } from '../MessageBox';

export const AlertDialogFields = ({ keyPrefix }: { keyPrefix?: string }) => {
  const k = makeKFunc(keyPrefix);
  const form = useActionEditorFormContext();

  const type = form.getInputProps(k`type`).value;

  if (type !== 'alert_dialog') {
    return null;
  }

  const imageFieldOps = wrapImageUploadProps({
    value: form.getInputProps(k`attribute_schema.image`).value,
    setValue: (v) => form.setFieldValue(k`attribute_schema.image`, v),
  });

  const subActionType = form.getInputProps(
    k`attribute_schema.action.type`,
  ).value;

  return (
    <>
      <TextInput
        label="標題"
        withAsterisk
        placeholder="請輸入標題"
        key={form.key(k`attribute_schema.title`)}
        {...form.getInputProps(k`attribute_schema.title`)}
      />
      <Textarea
        label="內文"
        withAsterisk
        placeholder="請輸入內文"
        minRows={3}
        autosize
        key={form.key(k`attribute_schema.message`)}
        {...form.getInputProps(k`attribute_schema.message`)}
      />
      <FileInput
        accept="image/png,image/jpeg"
        placeholder="比例：280x172 px（橫式）"
        rightSection={<IconUpload />}
        label="圖片"
        value={imageFieldOps.file}
        onChange={(file) => {
          if (!file) return;
          imageFieldOps.upload(file);
        }}
      />
      <TextInput
        label="接受按鈕的文案"
        withAsterisk
        placeholder="請輸入接受按鈕的文案"
        key={form.key(k`attribute_schema.positive_button`)}
        {...form.getInputProps(k`attribute_schema.positive_button`)}
      />
      <SelectSubAction
        label="接受按鈕的點擊行為"
        withAsterisk
        key={form.key(k`attribute_schema.action.type`)}
        {...form.getInputProps(k`attribute_schema.action.type`)}
        onChange={(value) => {
          if (value === 'open_link') {
            form.setFieldValue(
              k`attribute_schema.action`,
              openLinkFormValueInit,
            );
          }
          if (value === 'message_box') {
            form.setFieldValue(
              k`attribute_schema.action`,
              messageBoxFormValueInit,
            );
          }
        }}
      />
      <Box pl={10}>
        {subActionType === 'open_link' && (
          <OpenLinkFields keyPrefix={k`attribute_schema.action`} />
        )}
        {subActionType === 'message_box' && (
          <MessageBoxFields keyPrefix={k`attribute_schema.action`} />
        )}
      </Box>
      <TextInput
        label="拒絕按鈕的文案"
        withAsterisk
        placeholder="請輸入拒絕按鈕的文案"
        description="此按鈕行為為統一關閉視窗"
        key={form.key(k`attribute_schema.negative_button`)}
        {...form.getInputProps(k`attribute_schema.negative_button`)}
      />
    </>
  );
};

export const AlertDialogPreview = ({ value }: { value: AlertDialogAction }) => {
  const { attribute_schema: attributes } = value;
  const imageSrc = attributes.image;

  return (
    <div className={styles.preview}>
      <div className={styles.hero}>
        {imageSrc && <img src={imageSrc} alt="hero placeholder" />}
      </div>
      <div className={styles.body}>
        <div className={styles.title}>{attributes.title || '{標題}'}</div>
        <div className={styles.content}>
          {attributes.message ||
            '{內文內文內文內文內文內文內文內文內文內文內文內文}'}
        </div>
      </div>
      <div className={styles.ctaRow}>
        <button className={styles.cancelBtn}>
          {attributes.negative_button || '取消'}
        </button>
        <button className={styles.confirmBtn}>
          {attributes.positive_button || '確認'}
        </button>
      </div>
    </div>
  );
};
